module.exports = __webpack_public_path__ + "static/img/mechanism-1.029bc76b.png";